// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"ef640441","239":"e39fb35b","455":"c81af333","512":"3bd2fdb8","795":"0098cbbc","970":"6e7d3e7d","977":"240addac","980":"ebc67daa"}[chunkId] + ".chunk.js";
};